import styled from 'styled-components'
import { daysOfWeek } from './constants'

export const CalendarModalContainer = styled.div`
  width: min-content;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: 4px;
  height: 355px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 4px;
`

export const Header = styled.label`
  position: relative;
  width: 100%;
  padding: 0.5rem 1rem;

  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const LastDates = styled.p`
  position: relative;

  color: ${props => props.theme.colors.color122d52};
  text-align: center;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
`

export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: #ccc;
    border-radius: 34px;
    -webkit-transition: 0.4s;
    transition: 0.4s;

    &:before {
      content: '';

      position: absolute;
      height: 16px;
      width: 16px;
      left: 4px;
      bottom: 4px;
      background-color: ${({ theme }) => theme.zds.colors.neutral1000};
      border-radius: 50%;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
  }

  input:checked + span {
    background-color: ${props => props.theme.colors.color2196f3};
  }

  input:checked + span:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
`

export const PeriodManager = styled.div`
  position: relative;
  padding: 10px 14px;
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ManagerBlock = styled.div<{ type: 'year' | 'month' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: ${props => (props.type === 'month' ? '108px' : 'auto')};

  svg {
    width: 8px;
    height: 8px;
    fill: ${props => props.theme.colors.color122d52};
  }

  button {
    padding: 3px;

    font-size: 0;
    border: 0;
    background: transparent;
    border: 1px solid transparent;
    cursor: pointer;

    display: flex;
    align-items: center;
  }

  span {
    color: ${props => props.theme.colors.color122d52};
    text-align: center;
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
  }
`

export const SelectedDatesContainer = styled.div`
  position: relative;
  height: 100%;
  padding: 1rem 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`

export const SelectedDatesLabel = styled.p`
  padding: 0 40px;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.color1f6ecd};
  text-align: center;
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
`

export const SelectedDate = styled.p`
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`

export const CloseButton = styled.button`
  width: 14px;
  height: 14px;
  border-radius: 50%;

  background: ${props => props.theme.colors.colore4e8ef};
  border: none;
  cursor: pointer;

  svg {
    fill: ${props => props.theme.colors.color545e6c};
    width: 8px;
  }

  &:hover {
    filter: brightness(0.95);
  }
`

export const ClearSelectedDatesButton = styled.button`
  padding: 4px 8px;
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: 4px;

  text-decoration: underline;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
  white-space: nowrap;
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;

  &:hover {
    background: ${props => props.theme.colors.colorf3f5f9};
  }
`

export const MonthDaysContainer = styled.div`
  position: relative;
  width: 100%;
`

export const DaysStringContainer = styled.div`
  padding: 4px 1rem 1rem;
  display: grid;
  grid-template-columns: repeat(${daysOfWeek.length}, 1fr);
  gap: 0.5rem;
  cursor: default;

  span {
    text-transform: uppercase;
    color: ${props => props.theme.colors.color545e6c};
    text-align: center;
    font-family: 'Inter';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const DaysNumbersContainer = styled.div`
  padding: 0 20px 20px;
  display: grid;
  grid-template-columns: repeat(${daysOfWeek.length}, 1fr);
  gap: 0.5rem;
  justify-items: center;
  border-radius: 5px;
  border: 1px solid transparent;

  cursor: pointer;

  &:focus-visible {
    border: 1px solid ${props => props.theme.colors.colora7abb2};
  }
`

interface DaysNumberProps {
  isSelectedDay: boolean
}

export const DaysNumber = styled.button<DaysNumberProps>`
  position: relative;
  width: 24px;
  height: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: ${props => (props.isSelectedDay ? props.theme.colors.color005597 : 'transparent')};

  transition: background 0.1s ease-in-out;

  span {
    color: ${props => (props.isSelectedDay ? props.theme.zds.colors.neutral1000 : props.theme.colors.color545e6c)};
    text-align: center;
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    transition: all 0.1s ease-in-out;
  }

  &:disabled {
    cursor: none;
    pointer-events: none;

    span {
      color: ${props => props.theme.colors.colorDCE3ED};
    }
  }

  &:hover:not(:disabled) {
    background: ${props => props.theme.colors.color005597};

    span {
      color: ${({ theme }) => theme.zds.colors.neutral1000};
    }
  }
`

export const Footer = styled.div`
  position: relative;
  width: 100%;
  padding: 8px 16px;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
`

export const FooterButton = styled.button<{ isActive?: boolean }>`
  padding: 4px 8px;

  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: 4px;

  color: ${props => (props.isActive ? props.theme.colors.color1f6ecd : props.theme.colors.color545e6c)};
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;

  &:hover {
    background: ${props => props.theme.colors.colorf3f5f9};
  }
`
